import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import HomeLayout from "./Layouts/HomeLayout";
import AuthLayout from "./Layouts/AuthLayout";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import Aos from "aos";

import AdminDashboard from "./components/AdminDashboard";
import Order from "./pages/Order";
import Inventory from "./pages/Inventory";
import EmailReset from "./pages/EmailReset";
import PasswordReset from "./pages/PasswordReset";
import Poulet from "./pages/Poulet";
import Poulailler from "./pages/Poulailler";
import Mouton from "./pages/Mouton";
import NotFound from "./pages/NotFound";
import MoutonDetails from "./pages/MoutonDetails";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "product",
        element: <Product />,
        // loader: (args) => productLoader(1, args),
      },

      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        errorElement: <NotFound />,
      },

      {
        path: "admin",
        element: <AdminDashboard />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "order",
        element: <Order />,
      },
      {
        path: "pondeuse",
        element: <Poulet />,
      },
      {
        path: "poulailler",
        element: <Poulailler />,
      },
      {
        path: "mouton",
        element: <Mouton />,
      },

      {
        path: "mouton_details",
        element: <MoutonDetails />,
      },
      {
        path: "inventory",
        element: <Inventory />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
    future: {
      v7_partialHydration: true,
    },
  },
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <Login />,
      },

      {
        path: "sign_up",
        element: <SignUp />,
      },

      {
        path: "email_reset",
        element: <EmailReset />,
      },
      {
        path: "password_reset",
        element: <PasswordReset />,
      },
    ],
  },
]);

export default function App() {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);
  return (
    <div className="App bg-gray-200">
      <GoogleOAuthProvider clientId={process.env.REACT_APP_AUTH_CLIENT_ID}>
        <RouterProvider router={router} />
        <ToastContainer position="top-center" />
      </GoogleOAuthProvider>
    </div>
  );
}
